import { PenTool } from 'lucide-react';
import type { ReactElement } from 'react';

interface ProductExtractButtonProps {
  readonly hasSurface: boolean;
  readonly pressed: boolean;
  readonly disabled: boolean;
  readonly onToggle: () => void;
}

/** 제어점 도구 — 누르면 사진 위 포인터가 점 찍기 커서로 바뀐다. 시스템은 점을 미리 놓지 않는다. */
export const ProductExtractButton = ({
  hasSurface,
  pressed,
  disabled,
  onToggle,
}: ProductExtractButtonProps): ReactElement => (
  <button
    type="button"
    className="inline-flex items-center gap-1.5 rounded border px-3 py-2"
    disabled={disabled}
    aria-pressed={pressed}
    onClick={onToggle}
  >
    <PenTool aria-hidden="true" className="size-4" />
    {hasSurface ? '다시 추출하기' : '상품 추출하기'}
  </button>
);
